import React from 'react';
import { List, TextInput, BooleanInput, Filter } from 'react-admin';

import DeviceTaskDataGrid from './DeviceTaskDataGrid';

const DeviceTaskFilter = (props) => (
	<Filter {...props}>
		<TextInput source="name" alwaysOn />
		<TextInput source="registerId" alwaysOn />
		<BooleanInput source="active" alwaysOn />
	</Filter>
);

const DeviceTaskList = (props) => (
	<List
		filters={<DeviceTaskFilter />}
		filterDefaultValues={{ active: true }}
		sort={{ field: 'createdAt', order: 'DESC' }}
		bulkActionButtons={false}
		{...props}
	>
		<DeviceTaskDataGrid />
	</List>
);

export default DeviceTaskList;
